/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useSearchParams } from "react-router-dom"

export const DropdownWindow = ({ options }) => {
  const [searchParams, _] = useSearchParams()

  return <div className="absolute bg-clouds-100 dark:bg-midnight-700 border-2 border-clouds-950 dark:border-midnight-200 rounded-xl p-2 z-50 right-0 drop-shadow-sm text-clouds-900 dark:text-midnight-50">
    <ul className="list-none">
      {Array.from(options, (option) => {
        const { title, key, handler, active } = option

        return <li className="rounded-lg w-20 sm:w-28 hover:bg-custom-gray-600 hover:bg-opacity-60 dark:hover:bg-custom-gray-500 dark:hover:bg-opacity-60" key={key}>
          <button
            className="rounded-full p-1 w-full text-left cursor-pointer"
            style={{ fontWeight: active ? "bold" : "", backgroundColor: active ? "" : "" }}
            onClick={handler}>
            {title}
          </button>
        </li>
      })}
    </ul>
  </div>
}